import { motion, useInView } from "framer-motion";
import React, { useRef } from "react";

const HeroSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    amount: 0.2
  });
  const isImageInView = useInView(imageRef, {
    once: true,
    amount: 0.3
  });
  
  return <div ref={ref} className="relative min-h-[70vh] sm:min-h-[70vh] min-h-[55vh] bg-gradient-to-b from-[#17182c] via-[#222043] to-[#292040] overflow-hidden flex items-center w-full max-w-full">
      {/* Decorative gradients */}
      <div className="absolute -top-32 -left-24 w-[340px] h-[340px] rounded-full bg-heaven-gold/30 blur-3xl z-0"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[280px] rounded-full bg-blue-400/15 blur-2xl z-0"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-[#1a2a3a]/80 to-[#403E43]/50 z-0"></div>

      <div className="w-full max-w-full px-4 md:px-8 relative z-10 py-16 md:py-24">
        <div className="container mx-auto max-w-6xl relative">
          <div className="flex flex-col md:flex-row items-center justify-between gap-16 md:gap-24">
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 40
          }} transition={{
            duration: 0.7,
            ease: [0.22, 1, 0.36, 1]
          }} className="w-full md:w-1/2 text-left relative z-10">
              <h1 className="text-4xl sm:text-5xl font-playfair mb-5 leading-tight text-white drop-shadow font-bold py-[7px] md:text-7xl pt-8 sm:pt-0 break-normal">
                Apologetics <span className="text-heaven-gold">Tools</span>
              </h1>
              
              <p className="text-lg md:text-2xl font-playfair text-heaven-gold mb-6">
                Be Ready to Answer. Be Rooted in Truth.
              </p>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-heaven-gold/15 shadow-xl mb-6">
                <p className="text-base text-white/80 mb-2">
                  Selah is your daily guide for defending the faith, applying the Word, and walking in wisdom.
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 text-sm">
                  <li>
                    Explore the toughest questions and objections from atheism, secularism, and rival faiths.
                  </li>
                  <li>
                    Discover answers deeply rooted in Scripture, logic, and the heart of the gospel.
                  </li>
                  <li>
                    Train to share your faith with clarity and Christlike compassion.
                  </li>
                </ul>
              </div>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {
              opacity: 0,
              y: 20
            }} transition={{
              delay: 0.3,
              duration: 0.7
            }} className="mt-2">
                <p className="italic text-white/70 font-playfair">
                  "But in your hearts revere Christ as Lord. Always be prepared to give an answer..." <br />
                  <span className="text-heaven-gold">— 1 Peter 3:15</span>
                </p>
              </motion.div>
            </motion.div>

            {/* Right image column with increased spacing */}
            <div ref={imageRef} className="w-full md:w-1/2 mt-8 md:mt-0 flex justify-end items-center">
              <div className="relative">
                {/* Glow effect behind image */}
                <div className="absolute -inset-4 bg-gradient-to-tr from-heaven-gold/30 via-blue-500/10 to-white/10 rounded-2xl blur-2xl"></div>
                
                <motion.img initial={{
                opacity: 0,
                y: 100
              }} animate={isImageInView ? {
                opacity: 1,
                y: 0
              } : {
                opacity: 0,
                y: 100
              }} transition={{
                duration: 1.2,
                ease: [0.22, 1, 0.36, 1],
                delay: 0.2
              }} src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//apologetichero.png" alt="Apologetics Tools" className="relative z-10 max-h-[340px] w-auto object-contain rounded-lg" loading="eager" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default HeroSection;
